export class AutoryzujDoOswiadczeniaModel {
  kod: string;
}
